// Espelha backend app/schemas/autosped/*.py (snake_case).

export type StatusAgg = "concluido" | "parcial" | "processando" | "erro" | "pendente";

/** Uma linha da lista de Autosped — agregado por empresa. */
export interface EmpresaRow {
  client_id: number;
  legal_name: string;
  document_masked: string;
  origem: string | null;
  ultimo_recebido: string | null;
  total: number;
  ok: number;
  erro: number;
  processando: number;
  pendente: number;
  status_agg: StatusAgg;
  tipo_breakdown: Record<string, number>; // label do sistema → contagem
}

/** Um arquivo SPED no detalhe da empresa. */
export interface SpedFile {
  id: number;
  dispatch_id: number;
  sistema: string;
  tipo_sped: string; // label (EFD-Contribuições, …)
  tipo: string | null; // original | retificadora
  competencia: string | null; // "abr/2026" | "2024"
  periodo_inicio: string | null;
  periodo_fim: string | null;
  tamanho_bytes: number | null;
  nome_arquivo: string | null;
  num_recibo: string | null;
  status: string;
  error_message: string | null;
  received_at: string | null;
}

export interface EmpresaListParams {
  status_agg?: StatusAgg;
  origem?: string;
  data_de?: string;
  data_ate?: string;
  q?: string;
  limit?: number;
  offset?: number;
}

export interface FileListParams {
  data_de?: string;
  data_ate?: string;
  sistema?: string;
  tipo?: string;
  status?: string;
  q?: string;
  limit?: number;
  offset?: number;
}

export interface DispatchCreatePayload {
  client_ids: number[];
  sistemas: string[];
  inicio_periodo: string;
  fim_periodo: string;
  forcar_redownload?: boolean;
}

export interface DispatchCreateResult {
  criados: number[];
  erros: Array<Record<string, unknown>>;
}

/** Sistemas SPED suportados (espelha SISTEMA_MAP do backend). */
export const SISTEMA_OPTIONS: { value: string; label: string }[] = [
  { value: "1", label: "ECD" },
  { value: "2", label: "EFD-ICMS/IPI" },
  { value: "7", label: "EFD-Contribuições" },
  { value: "20", label: "ECF" },
  { value: "33", label: "EFD-Reinf" },
];

export const FILE_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: "baixado", label: "Concluído" },
  { value: "pendente", label: "Pendente" },
  { value: "erro", label: "Com erro" },
  { value: "ignorado_ja_processado", label: "Ignorado (já baixado)" },
  { value: "enviado_importacao", label: "Enviado p/ importação" },
];
